import { Link } from "react-router-dom";
import { NAV, BRAND } from "../../data/site";
import { CTAButton } from "../common/CTAButton";

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms (Advertisers)", to: "/terms-advertisers" },
  { label: "Terms (Societies)", to: "/terms-societies" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      {/* CTA band */}
      <div className="container-px py-20 md:py-28 border-b border-white/10">
        <div className="max-w-4xl">
          <h2 className="font-display font-800 text-4xl md:text-6xl tracking-tight text-balance">
            Ready to put your community's screens to work?
          </h2>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <CTAButton to="/societies" variant="primary" data-testid="footer-cta-society">
              Partner Your Society
            </CTAButton>
            <CTAButton to="/advertisers" variant="ghostLight" data-testid="footer-cta-advertise">
              Start Advertising
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="container-px py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/adx-logo.png" alt="AdX logo" className="h-12 w-12 rounded-lg" />
          <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
            {BRAND.subline}
          </p>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-white/40">
            A {BRAND.parent} Venture · {BRAND.domain}
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-teal">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-white/70 hover:text-white transition-colors">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-teal">Contact</h4>
          <ul className="mt-5 space-y-3 text-white/70">
            <li><a href={`mailto:${BRAND.email}`} onClick={() => window.dataLayer?.push({ event: "contact_click" })} className="hover:text-white transition-colors">{BRAND.email}</a></li>
            <li><a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} onClick={() => window.dataLayer?.push({ event: "contact_click" })} className="hover:text-white transition-colors">{BRAND.phone}</a></li>
            {BRAND.offices.map((o) => (
              <li key={o.city} className="text-white/50 text-sm">{o.city} · {o.address}</li>
            ))}
          </ul>
          <Link to="/contact" className="mt-5 inline-block text-teal hover:text-teal-bright transition-colors font-medium">
            Get in touch →
          </Link>
        </div>
      </div>

      <div className="container-px py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/40 text-sm">
        <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        <div className="flex gap-6">
          {LEGAL.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};
